import { gql } from "@apollo/client";

export default gql`
  mutation saveOrgTalentIndicator(
    $organizationId: Int!
    $talentIndicatorType: TalentIndicatorType!
    $customName: String
    $questionTitle: String
    $description: String
    $scaleStartsAt: Int
    $scale: Int
    $labels: [String]
    $labelDescriptions: [String]
  ) {
    updateTalentIndicator(
      organizationId: $organizationId
      talentIndicatorType: $talentIndicatorType
      customName: $customName
      questionTitle: $questionTitle
      description: $description
      scaleStartsAt: $scaleStartsAt
      scale: $scale
      labels: $labels
      labelDescriptions: $labelDescriptions
    ) {
      talentIndicator {
        id
        talentIndicatorType
        name
        customName
        questionTitle
        description
        scaleStartsAt
        scale
        labels
        labelDescriptions
        isManagerIndicator
        hasLockedLabels
      }
    }
  }
`;
